import ApiService from './ApiService.js';
const uuidv1 = require('uuid/v1');
import moment from 'moment'
const querystring = require('querystring')
var DocumentService = {

    findAll: function($data)
    {
       return new Promise(function(resolve,reject) {
           var $options= {};
           $options.url ="document"
           $options.method="get"
           if($data) {
               $options.url='document?'+ querystring.stringify($data)
           }
           ApiService.request($options)
               .then(response => { 
         
                   resolve(response.data.data)
               }).catch(error=> {
                   reject(error);
               })
       });

   },


    findOne: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="document/"+$data.id
            console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
  
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    getDataAsTree: function($data)
    {
       return new Promise(function(resolve,reject) {
           var $options= {};
           $options.url ="documentTree"
           $options.method="get"
           if($data) {
               $options.url='documentTree?'+ querystring.stringify($data)
           }
           ApiService.request($options)
               .then(response => { 
         
                   resolve(response.data.data)
               }).catch(error=> {
                   reject(error);
               })
       });
 
   },
    save: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data
            console.log($data)
       
            $options.url = "document/"+$data.id;
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    upload: function($file)
    {
       return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'documentUpload'
            $options.method="post"
            $options.data = $file
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    create: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data;
            $options.url = "document";
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    getImage: function($data)
   {
      return new Promise(function(resolve,reject) {
          var $options= {};
         // $options.responseType="blob"
          $options.url ="getImageFromDocument/?"+querystring.stringify($data)
          $options.method="get"
          ApiService.request($options)
              .then(response => { 
                  
                  resolve(response.data)
              }).catch(error=> {
                  reject(error);
              })
      });
    },

 
};
export default DocumentService;